var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "volcano-plot-content" },
    [
      !!_vm.chartName
        ? _c("download-chart", {
            attrs: { filename: _vm.chartName, chartId: _vm.plotId },
          })
        : _vm._e(),
      _c("div", {
        staticClass: "clicked_dot_value hidden",
        attrs: { id: _vm.clicked_dot_value },
      }),
      !!_vm.renderConfig.legend
        ? _c("div", {
            staticClass: "volcano-plot-legend",
            domProps: { innerHTML: _vm._s(_vm.renderConfig.legend) },
          })
        : _vm._e(),
      !!_vm.renderConfig
        ? _c("canvas", {
            staticClass: "volcanoPlot",
            attrs: {
              id: _vm.plotId,
              width: _vm.renderConfig.width + 120,
              height: _vm.renderConfig.height + 120,
            },
            on: {
              mouseleave: _vm.hidePanel,
              mousemove: _vm.checkPosition,
              click: _vm.filterTable,
            },
          })
        : _vm._e(),
      !!_vm.renderConfig.label
        ? _c("div", {
            staticClass: "volcano-plot-label",
            domProps: { innerHTML: _vm._s(_vm.renderConfig.label) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }